import { useState } from 'react';

/**
 * Hook that determines the visibility state for the emoji picker state.
 *
 * @param {Object} props  The hook props.
 *
 * @returns {Array} result  The hook payload.
 * @returns {Boolean} result[0]  Flag indicating if picker is open.
 * @returns {Function} result[1]  Function to set the visibility state.
 */
const usePickerState = (props) => {

	const { uncontrolled, isOpen, setIsOpen } = props;

	const [uncontrolledIsOpen, uncontrolledSetIsOpen] = useState(false);

	if (uncontrolled) {
		return [uncontrolledIsOpen, uncontrolledSetIsOpen];
	}

	return [isOpen, setIsOpen];

};

export default usePickerState;
